import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './idb-multistep-card.css.lit';
import { IdbMultistepContainer } from '../idb-multistep-container/idb-multistep-container';

/**
 * The IDB Multistep Card component
 * @element idb-multistep-card
 * @property number - The number label of the card. `1`
 * @property title - The title of the card.
 * @property position - The position of the card in a row.
 * @property active - The active state of the card.
 * @property id - The id of the card.
 * @slot summary - The summary of the card.
 * @slot panel - The multistep panel of the card.
 */

type Position = 'first' | 'last' | 'single';

@customElement('idb-multistep-card')
export class IdbMultistepCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'card-number' })
  cardNumber: string;

  @property({ type: String, attribute: 'card-title' })
  cardTitle: string;

  @property({ type: String, attribute: 'position' })
  position: Position;

  @property({ type: Boolean, reflect: true, attribute: 'active' })
  active = false;

  @property({ type: String, reflect: true })
  id: string = Math.floor(Math.random() * 10000).toString();

  setActive(event: Event) {
    event.preventDefault();
    const parentWrapper = this.parentElement as IdbMultistepContainer;

    const activeCards = [...parentWrapper.cards].filter(
      card => card.active == true
    );

    if (activeCards.length < 1) {
      this.active = true;
    }

    if (activeCards.length > 0) {
      activeCards.map(card => {
        if (card.id === this.id) {
          this.active = false;
        } else {
          card.active = false;
          this.active = true;
        }
      });
    }
  }

  handlePanelClick(event: Event) {
    event.stopPropagation();
  }

  render(): TemplateResult {
    const cardClasses = {
      'multistep-card': true,
      'multistep-card--open': this.active,
      'multistep-card--first': this.position === 'first',
      'multistep-card--last': this.position === 'last',
      'multistep-card--single': this.position === 'single',
    };

    return html`
      <div class="${classMap(cardClasses)}">
        <a href="#" @click=${this.setActive}>
          <div class="card-number">
            <div class="card-number__button">
              ${this.cardNumber}
            </div>
          </div>
          <div class="card-title">
            <div class="card-title-container">
            ${this.cardTitle}
            </div>
          </div>
          <div class="card-content">
            <div class="card-summary">
              <slot name="summary"></slot>
            </div>
            <div class="card-panel">
              <slot name="panel" @click=${this.handlePanelClick}></slot>
            </div>
          </div>
        </a>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idb-multistep-card': IdbMultistepCard;
  }
}
